    <div style="height:100%">
    <p class="highcharts-title ehs-title">
        Injury Free Days
    </p>
    <p class="ehs-sub-title">
        {{ehs_InjuryDays_TextPerformance}}
    </p>
    <label class="injury-free" >
        {{ehs_InjuryDays_Value}}
    </label>
    <p class="comment" style="text-align: center; width: 100%; font-size:medium;">
        {{ehs_InjuryDays_TextExplanation}}
    </p></div>